var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-meta"},[_vm._t("secondary",[_c('Button',{staticClass:"link help-link",attrs:{"href":"http://help.promo.ai/category/newsletters-by-promo-ai/","target":"_blank"}},[_vm._v(" Need Help? ")])]),_vm._t("primary")],2)}
var staticRenderFns = []

export { render, staticRenderFns }